import { useCallback } from "react"
import useApi from "./api"
import { useConsentValidator } from "./ConfigValidation"


export default function useWebometrics() {
    const { sendRequest } = useApi()
    const validateConsentId = useConsentValidator()

    const sendHomeMetrics = useCallback(async (company, consentId) => {
        let consent = ""
        if (validateConsentId(consentId)) {
            consent = consentId ? `&consentId=${consentId}` : ''
        }
        const path = `/webometrics/tela_inicial_consentimento/${company}?${consent}`
        const result = await sendRequest(path)
        return result
    }, [sendRequest, validateConsentId])


    const sendMoreMetrics = useCallback(async (company, data) => {
        let consent = ""
        let cpf = ""
        let cnpj = ""
        if (validateConsentId(data.consentId)) {
            consent = data.consentId ? `&consentId=${data.consentId}` : ''
        }
        if (data.cpf) {
            cpf = `&cpf=${data.cpf}`
        }
        if (data.cnpj) {
            cnpj = `&cnpj=${data.cnpj}`
        }

        const path = `/webometrics/tela_secundaria_continuar/${company}/${data.cpf || data.cnpj}?${cpf}${cnpj}${consent}`
        const result = await sendRequest(path)
        return result
    }, [sendRequest, validateConsentId])

    const sendEndMetrics = useCallback(async (company, data) => {
        let consent = ""
        let cpf = ""
        let cnpj = ""
        if (validateConsentId(data.consentId)) {
            consent = data.consentId ? `&consentId=${data.consentId}` : ''
        }
        if (data.cpf) {
            cpf = `&cpf=${data.cpf}`
        }
        if (data.cnpj) {
            cnpj = `&cnpj=${data.cnpj}`
        }

        const path = `/webometrics/tela_continuar_ou_finalizar/${company}/${data.cpf || data.cnpj}?${cpf}${cnpj}${consent}`
        const result = await sendRequest(path)
        return result
    }, [sendRequest, validateConsentId])

    const sendLetStartMetrics = useCallback(async (company, data) => {
        let consent = ""
        let cpf = ""
        let cnpj = ""
        if (validateConsentId(data.consentId)) {
            consent = data.consentId ? `&consentId=${data.consentId}` : ''
        }
        if (data.cpf) {
            cpf = `&cpf=${data.cpf}`
        }
        if (data.cnpj) {
            cnpj = `&cnpj=${data.cnpj}`
        }

        const path = `/webometrics/tela_vamos_comecar/${company}/${data.cpf || data.cnpj}?${cpf}${cnpj}${consent}`
        const result = await sendRequest(path)
        return result
    }, [sendRequest, validateConsentId])


    return { sendHomeMetrics, sendMoreMetrics, sendEndMetrics, sendLetStartMetrics }
}